import {Injectable} from '@angular/core';
import {environment} from '../../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import {Observable} from 'rxjs';
import {DeathStatusDTO} from '../models/DeathStatusDTO';

@Injectable({
  providedIn: 'root'
})
export class DeathStatusService {
  private url = environment.baseUrl + '/death-status';

  constructor(private httpClient: HttpClient) {}

  getDeathStatusByPersonId(personId: number): Observable<DeathStatusDTO> {
    return this.httpClient.get<DeathStatusDTO>(`${this.url}/byPersonId?personId=${personId}`);
  }

  getDeathStatusByPersonIdFromVendor(personId: number): Observable<DeathStatusDTO> {
    return this.httpClient.get<DeathStatusDTO>(`${this.url}/byPersonIdFromVendor?personId=${personId}`);
  }
}
